import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import type { UserRole } from '@/types';
import { hasRole } from '@/utils/permissions';

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

export function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (allowedRoles && user && !hasRole(user, ...allowedRoles, 'admin')) {
    return <Navigate to="/forbidden" replace />;
  }
  return <Outlet />;
}

/** Chỉ admin mới vào được /admin/* */
// export function AdminRoute() {
//   const { isAuthenticated, user } = useAuthStore();
//   const location = useLocation();

//   if (!isAuthenticated) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }
//   if (user?.role !== 'admin') {
//     return <Navigate to="/" replace />;
//   }
//   return <Outlet />;
// }

/** Guest only — nếu đã login admin thì redirect thẳng sang /admin */
export function GuestRoute() {
  // const { isAuthenticated, user } = useAuthStore();
  // if (isAuthenticated) {
  //   return <Navigate to={user?.role === 'admin' ? '/admin' : '/'} replace />;
  // }
  return <Outlet />;
}

export const PERMISSIONS = {
  canCreateTransfer: (role?: UserRole) => (role ? ['admin', 'restaurantseller', 'furnitureseller', 'landlord', 'franchiser'].includes(role) : false),
  canCreateJob: (role?: UserRole) => (role ? ['admin', 'headhunter', 'headhunterclient'].includes(role) : false),
  canApplyJob: (role?: UserRole) => (role ? ['jobseeker', 'admin'].includes(role) : false),
  canSendOffer: (role?: UserRole) => (role ? ['admin', 'restaurantbuyer', 'furniturebuyer', 'propertyseeker', 'franchiseseeker'].includes(role) : false),
};
